import styled from 'styled-components';
import { size, typography } from '@everlywell/leaves';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Icon = styled.img`
  width: ${size.xl1}px;
  height: ${size.xl1}px;
`;

export const Name = styled.p`
  ${typography.bodyTextSmall};
  font-weight: ${typography.weight.book};
  margin-left: ${size.xs1}px;

  a {
    ${typography.buttonTextSmall};
    text-decoration: none;
    cursor: default;
  }
`;
